import script from "./luckysdk.vue?vue&type=script&setup=true&lang=js"
export * from "./luckysdk.vue?vue&type=script&setup=true&lang=js"

import "./luckysdk.vue?vue&type=style&index=0&id=7f372a93&lang=less&scoped=true"
import "./luckysdk.vue?vue&type=style&index=1&id=7f372a93&lang=css"

import exportComponent from "/data/jenkins/workspace/pay.7pa.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f372a93"]])

export default __exports__